import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/storage";

var initializedPromise;
var app = null;
try {
  app = firebase.app();
  console.log("App already initialized", app.name);
} catch {
  initializedPromise = import(process.env.NODE_ENV === "production"
    ? "./config/fir_config.json"
    : "./config/debug_fir_config.json")
    .then(config => {
      app = firebase.initializeApp(config);
      console.log("App initialized", app.name);
      return app;
    })
    .catch(e => console.error("App initialization failed", e));
}
export default {
  isInitialized() {
    return app != null;
  },
  whenInitialized() {
    if (app) return Promise.resolve(app);
    return initializedPromise;
  },
  database() {
    return app.database();
  },
  storage() {
    return app.storage();
  },
  auth() {
    return app.auth();
  },
  functions() {
    return app.functions();
  },
  emailCredential(email, password) {
    return firebase.auth.EmailAuthProvider.credential(email, password);
  },
  recaptchaVerifier(container, parameters, app) {
    return new firebase.auth.RecaptchaVerifier(container, parameters, app);
  },
  authErrorMessage(error) {
    switch (error.code) {
      case "auth/invalid-email":
        return "FIRAuthErrorCodeInvalidEmail";
      case "auth/user-disabled":
        return "FIRAuthErrorCodeUserDisabled";
      case "auth/user-not-found":
      case "auth/wrong-password":
        return "FIRAuthErrorCodeWrongPassword";
      case "auth/email-already-in-use":
      case "link-in-team/email-already-used":
        return "FIRAuthErrorCodeEmailAlreadyInUse";
      case "link-in-team/bad-request":
        return "InternalErrorIsHappenedWeWorkingForIt";
      default:
        return "SomethingWentWrongSorryAboutThat";
    }
  }
};
